(function () {
    'use strict';
    realmCommerceApp.directive("initSelectPicker", InitSelectPicker);

    /*@ngInject*/
    function InitSelectPicker($interval) {
        return {
            restrict: 'EC',
            link: function (scope, elem, attr) {

                $interval(function () {
                    $(elem).selectpicker();
                }, 1000)
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/components/initselectpicker.directive.js